export enum GlTaxCodeProductTypeEnum {
  WARES = 'WARES',
  SERVICES = 'SERVICES',
  ANY = 'ANY',
}
